import React from 'react';

import keyBy from 'lodash/keyBy';

import { useQueries, useQueryClient } from '@lumapps/base-api/react-query';

import { getQueryInstance } from '../api';
import type { QueryInstanceOptions } from '../api/types';
import type { Instance } from '../types';

/**
 * Get instances by ids (batched and individually cached)
 */
export function useQueryInstancesByIds(
    ids: Array<string | Partial<Instance> | undefined>,
    options: QueryInstanceOptions = {},
) {
    const queryClient = useQueryClient();
    const queries = useQueries({
        queries: ids.map((id) => getQueryInstance(queryClient, id, options)),
    });
    const instanceById = React.useMemo(
        () => keyBy(queries.items?.filter(Boolean) as Array<Instance>, 'id'),
        [queries.items],
    );
    return { ...queries, instanceById };
}
